import React from "react";
import { Box } from "@mui/material";
import { formatDatetime } from "../../utils";


const PaxHistoryTable = ({ historyData = [] }) => {
  if (historyData?.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 3 }}>
        <p>No PAX history available</p>
      </Box>
    );
  }

  return (
    <Box sx={{ maxHeight: "400px", overflow: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
            <th style={{ padding: "12px 8px", textAlign: "left" }}>Date</th>
            <th style={{ padding: "12px 8px", textAlign: "center" }}>PAX</th>
          </tr>
        </thead>
        <tbody>
          {historyData?.map((record, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #f5f5f5" }}>
              <td style={{ padding: "12px 8px" }}>
                  {record?.created_at ? formatDatetime(new Date(record?.created_at), true, true, true) : "N/A"}
              </td>
              <td style={{ padding: "12px 8px", textAlign: "center" }}>
                {record?.pax_value || "N/A"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default PaxHistoryTable;